import Stack from 'atoms/Layout/Stack/Stack';
import styled from 'styled-components';

export const LargeBlockQuoteAvatar = styled(Stack)`
  align-self: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  overflow: hidden;
`;
